import { Socket } from 'socket.io-client'

import { createSocket, type SocketEmitList, type SocketEventList } from '@/core/transports'

export function useSocket<T extends keyof SocketEventList>(
  key?: T,
  handler?: SocketEventList[T],
): {
  emit?: Socket<SocketEventList, SocketEmitList>['emit']
  off: () => void
} {
  const config = useRuntimeConfig()
  const userStore = useBrickUserStore()

  const socketClient = createSocket(`https://io.${getHost(config)}`, userStore)

  let isSubscribed = false

  const subscribe = (): void => {
    if (!isSubscribed && key && handler) {
      socketClient?.io.on(key, handler as never)
      isSubscribed = true
    }
  }

  const unsubscribe = (): void => {
    if (isSubscribed && key && handler) {
      socketClient?.io.off(key, handler as never)
      isSubscribed = false
    }
  }

  // ------ immediately setup ------
  if (key && handler) {
    subscribe()
  }

  // ------ cleanup via onScopeDispose ------
  onScopeDispose(() => {
    unsubscribe()
  })

  return {
    emit: socketClient?.io.emit.bind(socketClient?.io),
    off: unsubscribe,
  }
}
